// The word "luokka" itself (Kielioppi § 2 topic luokat, 02-nouns.mdx; Axel 2026-10-21: the pages say "I-luokan",
// "kolmannen taivutusluokan", "verbiluokat" with no explanation). HV facts as 02-nouns.mdx (declensions),
// 03-adjectives.mdx (adjective classes) and 05-verbs.mdx (vowel and consonant stems) state them, and as
// the dictionary stores them (Lemma.declension 1–6 for nouns, 1–3 for adjectives; Lemma.verbClass).
import { defineTerms } from './define';

export const terms = defineTerms({
  luokka: {
    fi: {
      name: 'luokka',
      short:
        '**Luokka** on joukko sanoja, jotka taipuvat samalla tavalla: substantiivit kuuluvat kuuteen taivutusluokkaan, adjektiivit kolmeen luokkaan (I–III) ja verbit vartalonsa mukaan kahteen ryhmään.',
      compare: 'Suomen sanatyypit ovat sama ajatus: *talo*, *kala* ja *vesi* taipuvat kukin omalla tavallaan.',
      long: 'Luokan näkee yleensä sanakirjamuodon lopusta. Suku on eri asia kuin taivutusluokka, vaikka Duolingo ja oppitunnit 8 ja 9 kutsuvat sukuja substantiiviluokiksi.',
    },
    en: {
      name: 'class',
      short:
        'A **class** is a set of words that inflect the same way: nouns fall into six declensions, adjectives into three classes (I–III) and verbs by their stem into two groups.',
      compare: 'Finnish word types are the same idea: *talo*, *kala* and *vesi* each inflect their own way.',
      long: 'The class usually shows in the end of the dictionary form. Gender is not declension, even though Duolingo and lessons 8 and 9 call the genders noun classes.',
    },
    related: ['deklinaatio', 'adjektiiviluokka', 'vokaalivartalo', 'konsonanttivartalo', 'suku'],
    firstIn: 'luokat',
  },
});
